
import { Component, ElementRef, Input, OnInit, OnDestroy, TemplateRef, ViewChild, EventEmitter, Output } from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CommonService } from "../../services/commonService";
import { FormControl, FormGroup, Validators } from "@angular/forms";


@Component({
  selector: 'app-home-screen',
  templateUrl: './home-screen.component.html',
  styleUrls: ['./home-screen.component.css']
})
export class HomeScreenComponent implements OnInit {
  @ViewChild("responseModel") responseModel: TemplateRef<any>;
  @ViewChild("successModal") successModal: TemplateRef<any>;
  @ViewChild("cashinoutModel") cashinoutModel: TemplateRef<any>;
  @ViewChild("guyanaCashinoutModal") guyanaCashinoutModal: TemplateRef<any>;
  uuid: any;
  id; any;
  userId: any;
  phone: any;
  isUserAccess: any;
  errorMessage: string;
  countryCodes = [];
  successMessage: string;
  transactionForm = new FormGroup({
    countryCode: new FormControl('', Validators.required),
    phone: new FormControl('', Validators.required),
    amount: new FormControl('', Validators.required),
    otp: new FormControl('')
  })
  guyanaTransactionForm = new FormGroup({
    countryCode: new FormControl(''),
    phone: new FormControl(''),
    amount: new FormControl('', [Validators.required]),
    customerId: new FormControl(''),
    otp: new FormControl('')
  })
  responseData: any;
  customerDetails: any;
  isSvlBillerIntegrationEnabledYN: any;
  status: any;
  printLocationName: any;
  amount: any;
  date: any;
  operator: any;
  cashier: any;
  transactionId: any;
  referenceNo: any;
  printTransactionType: any;
  mobileNumber: any;
  printCustomerId: any;
  printStaticText: any;
  constructor(
    private commonService: CommonService,
    private router: Router,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    this.getDropdownList();
    this.isUserCanAddOrEdit();

  }
  generateUUID() {
    var deviceId: String = this.userId.toString();
    while (deviceId.length < 8) deviceId = "0" + deviceId;
    deviceId = deviceId.split("").reverse().join("") + deviceId;
    var deviceNumber = Number(deviceId);
    return (this.uuid = "WEB_" + deviceNumber.toString(36).toUpperCase());
  }
  getDropdownList() {
    let body = { dropdown: ["merchants", "countryCodes"] };
    document.getElementById("loader").style.display = "block";
    this.commonService.getDropdownValues(body).subscribe((res) => {
      document.getElementById("loader").style.display = "none";
      if (res.message.errorMessage == "") {
        this.userId = res.userInfo.userId;
        this.isSvlBillerIntegrationEnabledYN = res.list.isSvlBillerIntegrationEnabledYN;
        this.countryCodes = res.list.countryCodes;
        if(res.list.countryCodes) {
          this.transactionForm.controls.countryCode.setValue(this.countryCodes[0].id);
          this.guyanaTransactionForm.controls.countryCode.setValue(this.countryCodes[0].id);
        }

        this.generateUUID();

      } else {
        this.errorMessage = res.message.errorMessage;
        this.modalService.open(this.responseModel, { backdrop: 'static', keyboard: false });
      }
    });
  }

  isUserCanAddOrEdit() {
    let body = {
      deviceId: this.uuid,
      clientType: this.commonService.getClientType(),
      clientIp: this.commonService.getClientIP(),
    };
    document.getElementById("loader").style.display = "block";
    this.commonService.getAccessToFintech(body).subscribe((res) => {
      document.getElementById("loader").style.display = "none";
      if (res.message.errorMessage == '') {
        this.isUserAccess = res;
      } else {
        this.modalService.dismissAll();
        this.errorMessage = res.message.errorMessage;
        this.modalService.open(this.responseModel, { backdrop: 'static', keyboard: false });
      }
    });
  }

  gotoPath(route: string, key: string) {

    CommonService.fintechScreenName = key;
    this.router.navigateByUrl(route);

  }

  transactionType = '';
  showHide = false;
  showCustomerDetails = false;
  isSubmitted = false;
  successData: any;

  max10Length(event) {
    if (event.target.value.length > 10) {
      this.transactionForm.controls.phone.setValue(event.target.value.slice(0, 10));
    }
  }

  openCashinoutModal(type) {
    this.transactionType = type;
    this.showHide = false;
    this.formReset();
    this.modalService.open(this.cashinoutModel, {backdrop: 'static', keyboard: false });
  }

  openGuyanaCashinoutModal(type) {
    this.transactionType = type;
    this.showHide = false;
    this.formReset();
    this.modalService.open(this.guyanaCashinoutModal, {backdrop: 'static', keyboard: false });
  }


  searchGuyanaUserDetails() {
    if ((!this.guyanaTransactionForm.controls.countryCode.value || !this.guyanaTransactionForm.controls.phone.value) && !this.guyanaTransactionForm.controls.customerId.value) {
      this.isSubmitted = true;
      this.errorMessage = "Please provide either customer mobile number or customer ID";
      this.modalService.dismissAll();
      this.modalService.open(this.responseModel, { backdrop: 'static', keyboard: false });
      return;
    }
    let body = {
      "mobile": this.guyanaTransactionForm.controls.countryCode.value + (this.guyanaTransactionForm.controls.phone.value || ""),
      "userId": this.guyanaTransactionForm.controls.customerId.value || ""
    }
    document.getElementById("loader").style.display = "block";
    this.commonService.getGyUserDetails(body, false, 1).subscribe((res) => {
      document.getElementById("loader").style.display = "none"; 
      if (res.message.errorMessage == '') {
        this.showHide = true;
        this.showCustomerDetails = true;
        this.responseData=res.data[0];
        this.customerDetails=res.dynamicResponse[0];
        this.id=res.data[0].id;
        this.userId=res.data[0].userId;
        this.phone=res.data[0].mobile;
      } else {
        this.showHide = false;
        this.showCustomerDetails = false;
        this.formReset();
        this.modalService.dismissAll();
        this.errorMessage = res.message.errorMessage;
        this.modalService.open(this.responseModel, { backdrop: 'static', keyboard: false });
      }
    });
  }

  sendGuyanaOtpforTxn() {
    if (!this.guyanaTransactionForm.valid) {
      this.isSubmitted = true;
      return;
    }

    if(this.transactionType == 'CASH_IN') {
      this.showHide = true;
      this.showCustomerDetails = false;
      return;
    }

    let body = {
      "amount": this.guyanaTransactionForm.controls.amount.value,
      "consumerId": this.phone,
      "otp": "",
      "transactionType": this.transactionType
    }

    document.getElementById("loader").style.display = "block";
    this.commonService.cashinOut(body).subscribe((res) => {
      document.getElementById("loader").style.display = "none";
      if (res.message.errorMessage == '') {
        this.showHide = true;
        this.showCustomerDetails = false;
        this.guyanaTransactionForm.controls.otp.setValidators(Validators.required);
        this.guyanaTransactionForm.controls.otp.updateValueAndValidity();
      } else {
        this.showHide = false;
        this.showCustomerDetails = false;
        this.formReset();
        this.modalService.dismissAll();
        this.errorMessage = res.message.errorMessage;
        this.modalService.open(this.responseModel, { backdrop: 'static', keyboard: false });
      }
    });
  }

  confirmGuyanaTransaction() {
    if (!this.guyanaTransactionForm.valid) {
      this.isSubmitted = true;
      return;
    }
    let body1 = {      
      "amount": this.guyanaTransactionForm.controls.amount.value,
      "userId": this.id,
      "transactionType": this.transactionType
    }
    let body2 = {
      "amount": this.guyanaTransactionForm.controls.amount.value,
      "consumerId": this.phone,
      "otp": this.guyanaTransactionForm.controls.otp.value,
      "transactionType": this.transactionType
    }

    document.getElementById("loader").style.display = "block";
    if(this.transactionType=="CASH_IN"){
    this.commonService.cashInCashOutGy(body1).subscribe((res) => {
      document.getElementById("loader").style.display = "none";
      if (res.message.errorMessage == '') {
        this.modalService.dismissAll();
        this.successMessage = res.message.successMessage;
        this.successData = res.getTransactions.transactions[0];
        this.formReset();
        this.modalService.open(this.successModal, { backdrop: 'static', keyboard: false , windowClass: "successModal" });
      } else {
        this.showHide = false;
        this.showCustomerDetails = false;
        this.formReset();
        this.modalService.dismissAll();
        this.errorMessage = res.message.errorMessage;
        this.modalService.open(this.responseModel, { backdrop: 'static', keyboard: false });
      }
    });
  }
  else{
    this.commonService.cashinOut(body2).subscribe((res) => {
      document.getElementById("loader").style.display = "none";
      if (res.message.errorMessage == '') {
        this.modalService.dismissAll();
        this.successMessage = res.message.successMessage;
        this.successData = res.getTransactions.transactions[0];
        this.formReset();
        this.modalService.open(this.successModal, { backdrop: 'static', keyboard: false , windowClass: "successModal" });
      } else {
        this.showHide = false;
        this.showCustomerDetails = false;
        this.formReset();
        this.modalService.dismissAll();
        this.errorMessage = res.message.errorMessage;
        this.modalService.open(this.responseModel, { backdrop: 'static', keyboard: false });
      }
    });
  }
  }

  sendOtpforTxn() {
    if (!this.transactionForm.valid) {
      this.isSubmitted = true;
      return;
    }
 
    let body = {
      "amount": this.transactionForm.controls.amount.value,
      "consumerId": this.transactionForm.controls.countryCode.value + this.transactionForm.controls.phone.value,
      "otp": "",
      "transactionType": this.transactionType
    }
 
    document.getElementById("loader").style.display = "block";
    this.commonService.cashinOut(body).subscribe((res) => {
      document.getElementById("loader").style.display = "none";
      if (res.message.errorMessage == '') {
        this.showHide = true;
        this.transactionForm.controls.otp.setValidators(Validators.required);
        this.transactionForm.controls.otp.updateValueAndValidity();
      } else {
        this.modalService.dismissAll();
        this.formReset();
        this.errorMessage = res.message.errorMessage;
        this.modalService.open(this.responseModel, { backdrop: 'static', keyboard: false });
      }
    });
  }

    confirmTransaction() {
    if (!this.transactionForm.valid) {
      this.isSubmitted = true;
      return;
    }
    let body = {
      "amount": this.transactionForm.controls.amount.value,
      "consumerId": this.transactionForm.controls.countryCode.value + this.transactionForm.controls.phone.value,
      "otp": this.transactionForm.controls.otp.value,
      "transactionType": this.transactionType
    }
 
    document.getElementById("loader").style.display = "block";
    this.commonService.cashinOut(body).subscribe((res) => {
      document.getElementById("loader").style.display = "none";
      if (res.message.errorMessage == '') {
        this.modalService.dismissAll();
        this.successMessage = res.message.successMessage;
        this.successData = res.getTransactions.transactions[0];
        this.formReset();
        this.modalService.open(this.successModal, { backdrop: 'static', keyboard: false , windowClass: "successModal" });
      } else {
        this.modalService.dismissAll();
        this.showHide = false;
        this.transactionForm.controls.otp.clearValidators();
        this.transactionForm.controls.otp.updateValueAndValidity();
        this.errorMessage = res.message.errorMessage;
        this.modalService.open(this.responseModel, { backdrop: 'static', keyboard: false });
      }
    });
  }

  close() {
    this.showHide = false;
    this.isSubmitted = false;
    this.transactionForm.controls.otp.clearValidators();
    this.transactionForm.controls.otp.updateValueAndValidity();
    this.guyanaTransactionForm.controls.amount.setValue('');
    this.showCustomerDetails = false;
    this.guyanaTransactionForm.controls.otp.clearValidators();
    this.guyanaTransactionForm.controls.otp.updateValueAndValidity();
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  formReset() {
    this.showHide = false;
    this.isSubmitted = false;
    this.transactionForm.controls.otp.clearValidators();
    this.transactionForm.controls.otp.updateValueAndValidity();
    this.transactionForm.reset();
    this.transactionForm.controls.countryCode.setValue(this.countryCodes[0].id);
    this.guyanaTransactionForm.controls.otp.clearValidators();
    this.guyanaTransactionForm.controls.otp.updateValueAndValidity();
    this.guyanaTransactionForm.reset();
    this.guyanaTransactionForm.controls.countryCode.setValue(this.countryCodes[0].id);
  }

  max7Length(event) {
    if (event.target.value.length > 7) {
      this.guyanaTransactionForm.controls.phone.setValue(event.target.value.slice(0, 7));
    }
  }

  formatTransactionType(type: string): string {
  if (!type) return '';

  switch (type) {
    case 'CASH_IN':
      return 'Cash In';
    case 'CASH_OUT':
      return 'Cash Out';
    default:
      return type;
  }
}

    printGuyanaReceipt() {
    this.transactionId = this.successData.txnId;
    this.referenceNo = this.successData.referenceNumber;
    this.mobileNumber = this.successData.consumerMobile;
    this.status = this.successData.transactionStatus;
    this.amount = this.successData.amount;
    this.date = this.successData.transactionTime;
    this.printLocationName = this.successData.userData.currentLocation; 
    this.printTransactionType = this.successData.transactionType;
    this.printCustomerId = this.successData.customerUserId;
    this.cashier = this.successData.userData.cashier;
    this.operator = this.successData.userData.userId;
    this.printStaticText= this.successData.staticMessage;

    var newWin = window.open();
    newWin.document.write(`
      <div style="display: flex; flex-direction: column; height: auto; margin-top: 3rem;">
         <div style="display: flex; justify-content: center;">
           <img src="assets/img/home-screen/ibet-logo.jpg" alt="logo_Img" style="width: 20%;">
        </div>
        <div style="text-align: center; border-bottom: 2px dashed #808080; padding: 8px;"></div>
        <div style="text-align: center; padding: 6px 5px; font-weight: 600; font-size: 18px; padding-top: 8px;">
          MAKING WINNER EVERYDAY  
        </div>
        <div style="text-align: center; padding: 6px 5px; font-weight: 600; font-size: 18px; ">
        www.ibetgamessgy.com
        </div>
        <div style="text-align: center; padding: 6px 5px; font-weight: 600; font-size: 18px; ">
         A member of Supreme Ventures Group
        </div>
  <div style="text-align: center; border-bottom: 2px dashed #808080; padding: 8px;"></div>

        <div style="text-align: center; padding: 6px 5px; font-weight: 600; font-size: 20px; padding-top: 8px;padding-bottom: 10px;">
          Transaction Summary 
        </div>
        <div style="display: flex; justify-content: space-around; white-space: nowrap; width: 100% !important; font-weight: 500; font-size: 18px;">
          Transaction ID # &nbsp; : ${this.transactionId ? this.transactionId : ''}
        </div>
        <div style="text-align: center; padding: 6px 5px; font-weight: 500; font-size: 18px;">
          Reference Number &nbsp; : ${this.referenceNo ? this.referenceNo : ''}
        </div>
        <div style="text-align: center; padding: 6px 5px; font-weight: 500; font-size: 18px;">
          Transaction Type &nbsp; : ${this.formatTransactionType(this.printTransactionType)}
        </div>
        `);
           if (this.transactionType == 'CASH_IN') {
      newWin.document.write(`
        <div style="display: flex; flex-direction: row; margin: auto;">
          <div style="padding: 6px 5px; padding-left: 1rem; font-weight: 500; font-size: 18px;">Customer ID &nbsp;</div>
          <div style="padding: 6px 5px; font-weight: 500; font-size: 18px;">: ${this.printCustomerId? this.printCustomerId : ''}</div>
        </div>
      `);
    } 

    if (this.mobileNumber && this.mobileNumber !== "null" && this.mobileNumber !== "") {
      newWin.document.write(`
        <div style="display: flex; flex-direction: row; margin: auto;">
          <div style="padding: 6px 5px; padding-left: 1rem; font-weight: 500; font-size: 18px;">Mobile Number</div>
          <div style="padding: 6px 5px; font-weight: 500; font-size: 18px;">: ${this.mobileNumber}</div>
        </div>
      `);
    } 
    newWin.document.write(`
      <div style="text-align: center; padding: 6px 5px; font-weight: 500; font-size: 18px;">
          Status &nbsp; : ${this.status ? this.status : ''}
        </div>
      <div style="text-align: center; padding: 6px 5px; font-weight: 500; font-size: 18px;">
          Amount ($)  &nbsp; : ${Number(this.amount).toFixed(2)}
        </div>
      <div style="text-align: center; padding: 6px 5px; font-weight: 500; font-size: 18px;">
          Date &nbsp; : ${this.date ? this.date : ''}
        </div>
      <div style="text-align: center; padding: 6px 5px; font-weight: 500; font-size: 18px;">
          Cashier &nbsp; : ${this.cashier ? this.cashier : ''}
        </div>
      <div style="text-align: center; padding: 6px 5px; font-weight: 500; font-size: 18px;">
          Operator # &nbsp; : ${this.operator ? this.operator : ''}
        </div>
        <div style="text-align: center; padding: 6px 5px; font-weight: 500; font-size: 18px;">
          Location &nbsp; : ${this.printLocationName ? this.printLocationName : ''}
        </div>
          <div style="text-align: center; border-bottom: 2px dashed #808080; padding: 8px;"></div>
            <div style="text-align: center; padding: 6px 5px; font-weight: 600; font-size: 18px; padding-top: 8px;padding-bottom: 10px;">
         ${this.printStaticText ? this.printStaticText : ''}
        </div>
    `);
    newWin.document.write(`
        <div style="display: flex; justify-content: center;">
          <div style="font-size: larger; text-align: center; font-weight: 600; margin-top: 10px; margin-bottom: 20px;">
          </div>
        </div>
      </div>
    `);

    setTimeout(function () {
      newWin.focus();
      newWin.print();
      newWin.close();
    }, 500);
  }
}
